import { PartState } from '../types';
import { facingLeftState } from './facing-left';

/**
 * Flying left state — Bizy facing left and leaning 45° into flight.
 * Right arm extended upward like Superman in the direction of flight.
 */
export const flyingLeftState: PartState = {
	...facingLeftState,
	arms: [
		// Left arm extended upward — Superman pose (mirrored from flying-right)
		{ d: 'M131 130L116 95C114 89 111 83 108 78L96 62', side: 'left' },
		// Right arm trailing down (mirrored from flying-right)
		{ d: 'M149 145L161 170C162 173 164 176 166 178L178 190', side: 'right' },
	],
	bodyRotation: -45,
};
